import { Component, OnInit } from '@angular/core';
import { GridOptions } from '../../../core/components/grid/grid.types';
import { Grid } from '../../../core/components/grid/grid.model';

@Component({
  selector: 'tt-disc-grp-datas',
  templateUrl: './disc-grp-datas.component.html',
  styleUrls: ['./disc-grp-datas.component.css']
})
export class DiscGrpDatasComponent implements OnInit {
    public grid?: GridOptions;

    private createGrid() {
        if (!this.grid) {
            this.grid = new Grid()
                .setRememberId('w_discgrpdatas_grid')
                .setLoadDataFunction({
                    method: 3123,
                    parameters: {}
                })
                .setKendoConfig({ height: '100%' });
        }
    }

    private async init() {
        this.createGrid();
    }

    ngOnInit() {
        this.init();
    }
}



//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('discGrpDatas', {
//        templateUrl: 'views/components/views/discGrpDatas/discGrpDatas.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['ttGridFactory', function (ttGridFactory) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;

//            vm.model = {
//                gridReady: true
//            };

//            vm.grid = new ttGridFactory({
//                rememberId: 'w_discgrpdatas_grid',
//                kendo: {
//                    height: '100%',
//                    sortable: true,
//                    aggregate: true,
//                    pager: false,
//                    selectable: false,
//                    filterable: false
//                }
//            }).setLoadDataFunction({
//                method: 3123,
//                parameters: {}
//            });

//            // #endregion VARIABLES & DEFINITIONS

//        }]
//    });
//})();
